// Keep the wrong style import (common/env instead of common) due to
// scripts/env-check
import * as utils from '../../common/utils'
import { companiesLen, processEnv } from '../../common/env'

//#region companyLogos
const COMPANY_LOGOS_UNPARSED = processEnv['REACT_APP_COMPANY_LOGOS'] || ''

if (typeof COMPANY_LOGOS_UNPARSED !== 'string') {
  throw new TypeError(`REACT_APP_COMPANY_LOGOS envvar not an string`)
}

const COMPANY_LOGOS = COMPANY_LOGOS_UNPARSED.split(':')

export const companyToLogo: utils.ReadonlyRecord<string> = (() => {
  const res: Record<string, string> = {}

  for (const companiesToLogo of COMPANY_LOGOS) {
    const hasBadChars =
      companiesToLogo.includes(':') ||
      companiesToLogo.includes('"') ||
      companiesToLogo.includes("'")
    const hasCorrectChars = companiesToLogo.includes('=')
    const isValid = !hasBadChars && hasCorrectChars

    if (!isValid) {
      throw new TypeError('REACT_APP_COMPANY_LOGOS envvar malformed')
    }

    const [companiesStr = '', logo = ''] = companiesToLogo.split('=')

    if (companiesStr.length < 2 || logo.length < 100) {
      console.log('LOGO LENGTH: ', logo.length, ' ', logo)
      throw new TypeError('REACT_APP_COMPANY_LOGOS envvar malformed')
    }

    const companies = companiesStr.split(',')

    for (const company of companies) {
      if (company.length < 2 || company.includes('=')) {
        throw new TypeError('REACT_APP_COMPANY_LOGOS envvar malformed')
      }
      res[company] = 'data:image/png;base64,' + logo
    }
  }

  const logoCompaniesLen = utils.keys(res).length
  if (logoCompaniesLen !== companiesLen) {
    throw new Error(
      `There are ${companiesLen} companies but got ${logoCompaniesLen} from the logos`,
    )
  }

  return res
})()
//#endregion companyLogos
